export default {
  ERROR: 'checkout.lib.components.text.couponCanNotBeUsed',
  SERVERERROR: 'checkout.lib.error.serviceErrorAndTry',
  INFO: 'checkout.lib.components.text.newCouponApplied',
};
